export const EGFR_MIN = 5;
export const EGFR_MAX = 150;
export const EGFR_RANGE_MESSAGE = `eGFR must be between ${EGFR_MIN} and ${EGFR_MAX} mL/min/1.73m². Check that a creatinine value wasn't entered here.`;

export const isEgfrOutOfRange = (value) =>
  value !== undefined && value !== null && value !== '' && (Number(value) < EGFR_MIN || Number(value) > EGFR_MAX);

export const medicalConditionOptions = [
  { value: 'cancer', label: 'Cancer' },
  { value: 'heartProblems', label: 'Heart Problems' },
  { value: 'diabetes', label: 'Diabetes/Sugar' },
  { value: 'mentalHealthDisorders', label: 'Mental Health Disorders (e.g., bipolar, depression, anxiety, etc.)' },
  { value: 'obesity', label: 'Obesity' },
  { value: 'highBloodPressure', label: 'High Blood Pressure' },
  { value: 'badCholesterol', label: 'Bad Cholesterol' },
  { value: 'liverDisease', label: 'Liver Disease' },
  { value: 'kidneyDisease', label: 'Kidney Disease' },
  { value: 'stress', label: 'Stress' },
  { value: 'none', label: 'None of the above' }
];

export const contraindications = [
  { value: 'noPregnancy', label: 'I am not pregnant or nursing' },
  { value: 'noRecentSurgery', label: 'I have not had surgery in the past 6 months' },
  { value: 'noActiveInfection', label: 'I do not have an active infection or fever' },
  { value: 'noAllergies', label: 'I do not have allergies to medical adhesives' }
];

export const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' }
];
